import React from 'react';
import { Link } from "react-router-dom";
import './Footer.css';
import { wordpressRoot } from '../../configFile';

export default function Footer() {

  return (
    <div className='footer'>
      <Link to="/conditions-generales/">Conditions Générales</Link>
      <a href={wordpressRoot + "wp-admin"}>Espace réservé</a>
      <span>Copyright 2024©</span>
    </div>
  )
}
